/* The collection story opens like the product sizing drawer, without moving focus or scrolling the page. */
(() => {
  if (window.LoveCashmereCollectionStory) {
    window.LoveCashmereCollectionStory.init();
    return;
  }

  const selector = '[data-lc-collection-story]';
  const states = new WeakMap();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initialise(details) {
    if (states.has(details)) return;
    const summary = details.querySelector(':scope > summary');
    const panel = details.querySelector(':scope > .lc-collection-story__panel');
    if (!summary || !panel) return;
    const state = { expanded: details.open, animation: null };
    states.set(details, state);
    summary.setAttribute('aria-expanded', String(state.expanded));
    panel.inert = !state.expanded;

    function finish() {
      details.open = state.expanded;
      panel.style.removeProperty('height');
      panel.style.removeProperty('overflow');
      summary.setAttribute('aria-expanded', String(state.expanded));
      panel.inert = !state.expanded;
    }

    function setExpanded(expanded) {
      // Read the rendered height before cancelling, so a second press reverses from the current position.
      const startHeight = details.open ? panel.getBoundingClientRect().height : 0;
      if (state.animation) {
        const previous = state.animation;
        state.animation = null;
        previous.cancel();
      }
      state.expanded = expanded;
      summary.setAttribute('aria-expanded', String(expanded));
      panel.inert = !expanded;
      if (expanded) details.open = true;
      if (reducedMotion.matches || !panel.animate) {
        finish();
        return;
      }
      panel.style.height = `${startHeight}px`;
      panel.style.overflow = 'hidden';
      const endHeight = expanded ? panel.scrollHeight : 0;
      if (Math.abs(endHeight - startHeight) < 1) {
        finish();
        return;
      }
      const animation = panel.animate(
        [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
        { duration: 240, easing: 'ease-in-out' }
      );
      state.animation = animation;
      animation.onfinish = () => {
        if (state.animation !== animation) return;
        state.animation = null;
        finish();
      };
    }

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      setExpanded(!state.expanded);
    });
    details.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !state.expanded) return;
      event.preventDefault();
      event.stopPropagation();
      setExpanded(false);
      summary.focus({ preventScroll: true });
    });
    details.addEventListener('toggle', () => {
      // Native/editor changes remain authoritative; an external closure cancels an in-flight reveal.
      if (state.animation && !details.open) {
        const previous = state.animation;
        state.animation = null;
        previous.cancel();
        state.expanded = false;
        finish();
      } else if (!state.animation) {
        state.expanded = details.open;
        summary.setAttribute('aria-expanded', String(state.expanded));
        panel.inert = !state.expanded;
      }
    });
  }

  function init(scope = document) {
    if (scope.matches?.(selector)) initialise(scope);
    scope.querySelectorAll?.(selector).forEach(initialise);
  }
  window.LoveCashmereCollectionStory = { init };
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
})();
